import { createSelector } from "reselect";

export const normalizersSelector = createSelector(
    state => state.services.normalizers,
    state => state
);